/* Native random catalog pages. No visitor history or persistent index is used. */
(function () {
  'use strict';
  var LIMIT = 25000;
  var PAGE_SIZE = 8;
  function countBound(value) {
    if (!Number.isSafeInteger(value) || value < 1) throw new Error('Invalid catalog count');
    return Math.min(value, LIMIT);
  }
  function samplePages(total, previous, random) {
    var pageCount = Math.ceil(countBound(total) / PAGE_SIZE);
    var all = Array.from({ length: pageCount }, function (_, i) { return i + 1; });
    var blocked = new Set(previous || []);
    var available = all.filter(function (page) { return !blocked.has(page); });
    if (available.length < Math.min(4, all.length)) available = all;
    var pages = [];
    while (pages.length < 4 && available.length) {
      var index = Math.min(available.length - 1, Math.floor(random() * available.length));
      pages.push(available.splice(index, 1)[0]);
    }
    return pages;
  }
  function pageURL(route, origin, page, total) {
    if (!Number.isSafeInteger(page) || page < 1 || page > Math.ceil(countBound(total) / PAGE_SIZE)) throw new Error('Invalid page');
    var u = new URL(route, origin);
    if (u.origin !== origin || !/\/collections\/all\/?$/.test(u.pathname)) throw new Error('Invalid catalog origin');
    u.search = ''; u.hash = '';
    u.searchParams.set('section_id', 'oxp-discovery-catalog');
    u.searchParams.set('sort_by', 'created-descending');
    u.searchParams.set('page', String(page));
    return u.href;
  }
  function validItem(item, origin) {
    if (!item || typeof item.id !== 'string' || !/^[1-9]\d{0,19}$/.test(item.id) || typeof item.title !== 'string' || !item.title.trim()) return false;
    try {
      var url = new URL(item.url, origin);
      if (url.origin !== origin || !/\/products\/[^/]+$/.test(url.pathname) || url.search || url.hash) return false;
      if (item.image !== null) {
        if (typeof item.image !== 'string' || !item.image.trim()) return false;
        var image = new URL(item.image, origin);
        if (image.protocol !== 'https:' || (image.origin !== origin && image.hostname !== 'cdn.shopify.com')) return false;
      }
      return true;
    } catch (_) { return false; }
  }
  function createPager(options) {
    var total = countBound(options.total);
    var revision = 0; var abort;
    return {
      cancel: function () { revision++; if (abort) abort.abort(); },
      load: async function (previousPages) {
        this.cancel(); var ownRevision = revision;
        abort = new AbortController(); var signal = abort.signal;
        var timer = setTimeout(function () { if (ownRevision === revision) abort.abort(); }, options.timeoutMs || 10000);
        var pages = samplePages(total, previousPages, options.random || Math.random);
        try {
          var responses = await Promise.all(pages.map(async function (page) {
            try {
              var response = await options.fetcher(pageURL(options.route, options.origin, page, total), { signal: signal, credentials: 'same-origin', cache: 'no-store' });
              if (!response.ok) return null;
              var data = options.parse(await response.text());
              if (!data || data.page !== page || data.pageSize !== PAGE_SIZE || data.sort !== 'created-descending' || !Number.isSafeInteger(data.total) || data.total < 1 || data.total > LIMIT || !Array.isArray(data.items) || data.items.length > PAGE_SIZE || !data.items.every(function (item) { return validItem(item, options.origin); })) return null;
              if (page > Math.ceil(data.total / PAGE_SIZE) || data.items.length > Math.min(PAGE_SIZE, data.total - (page - 1) * PAGE_SIZE)) return null;
              return data;
            } catch (_) { return null; }
          }));
          if (ownRevision !== revision) return null;
          // A deadline only discards unfinished pages; completed pages can still fill a fresh selection.
          var successful = responses.filter(Boolean); var used = new Set();
          if (successful.length) total = Math.min.apply(Math, successful.map(function (p) { return p.total; }));
          // Catalog counts can shrink during a draw. Do not use pages beyond the smallest valid count.
          successful = successful.filter(function (p) { return p.page <= Math.ceil(total / PAGE_SIZE) && p.items.length <= Math.min(PAGE_SIZE, total - (p.page - 1) * PAGE_SIZE); });
          var items = successful.flatMap(function (p) { return p.items; }).filter(function (item) { if (used.has(item.id)) return false; used.add(item.id); return true; });
          if (items.length < Math.min(8, total)) throw new Error('Unable to load enough products');
          return { items: items, pages: successful.map(function (p) { return p.page; }), total: total };
        } finally { clearTimeout(timer); }
      }
    };
  }
  var api = { LIMIT: LIMIT, PAGE_SIZE: PAGE_SIZE, countBound: countBound, samplePages: samplePages, pageURL: pageURL, validItem: validItem, createPager: createPager };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window !== 'undefined') window.OpenXCatalogPages = api;
})();
